






































































import { Component, Emit, Vue } from 'vue-property-decorator';
import { demoServer, siteManagementServer, yunnanDataViewServer } from '@/api/installServer';
import PagingUnit from '@/components/paging/paging.vue';
import { TableStripe } from '@/mixins/tableStripe';
import DetailsDialogA from './box-9-unit-2.vue';
import DetailsDialogB from './box-9-unit-3.vue';
import DetailsDialogC from './box-9-unit-4.vue';

@Component({
  components: { PagingUnit, DetailsDialogA, DetailsDialogB, DetailsDialogC },
  mixins: [TableStripe],
})
export default class Home extends Vue {
  private visible = false;
  private title: any = '作业票列表';
  private form: any = {};
  private data: any = {};
  private total: any = 0;
  private tableData: any = [];
  oneColumnType = 'index'; // 决定第一列是索引还是选择
  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  type: any = 'device';
  finishFlag: any;
  deptName: any = '';
  searchTime: any = [];
  formData: any = {};

  private mounted() {}

  private async showDialog(data: any) {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.formData = data;
    this.searchTime = [data.startTime, data.endTime];

    this.getListData();
  }

  changeTime() {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.formData.startTime = this.searchTime[0] + ' 00:00:00';
    this.formData.endTime = this.searchTime[1] + ' 23:59:59';
    this.getListData();
  }

  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getListData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getListData();
  }

  getListData() {
    siteManagementServer
      .getSiteManagementList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        type: this.formData.type ? this.formData.type : null,
        startTime: this.formData.startTime,
        endTime: this.formData.endTime,
      })
      .then((res: any) => {
        this.total = res.data.total;
        this.tableData = res.data.records;
        this.visible = true;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  goDetails(data: any) {
    let DetailsDialogRef: any;
    if (data.type.indexOf('爆破') !== -1) {
      DetailsDialogRef = this.$refs['DetailsDialogRefA'];
    } else if (data.type.indexOf('停电') !== -1 || data.type.indexOf('送电') !== -1) {
      DetailsDialogRef = this.$refs['DetailsDialogRefB'];
    } else {
      DetailsDialogRef = this.$refs['DetailsDialogRefC'];
    }
    DetailsDialogRef.showDialog(data);
  }

  private hideDialog() {
    this.visible = false;
  }
}
